import {
  compose,
  withProps,
} from 'recompose';
import { createStringFromTemplate } from '../Helper';
import { addMetaTagToHead } from '../Helper';

const META_NAME = 'description';

const updateOrCreateMetaDescription = ({ storeName, metaDescription, label, t }) => {
  const isIndexRoute = label === '';
  const messageKey = 'navbar.meta_description' + (isIndexRoute ? '' : '_') + label.replace(/\s+/g, '').toLowerCase();
  const guaranteeSlogan = '✓ 100% Quality Guaranteed ✓ Customisation Available';
  const description = createStringFromTemplate(metaDescription, {
    storeName,
    guaranteeSlogan
  });
  const fullDescription = `${t(messageKey, description, { 'storeName': storeName, 'guaranteeSlogan': guaranteeSlogan })}`;
  const desc = document.querySelector(`meta[name="${META_NAME}"]`);
  if (desc) {
    desc.setAttribute('content', fullDescription);
  } else {
    addMetaTagToHead({ name: META_NAME, content: fullDescription });
  }
};

export const withMetaData = compose(
  withProps(({ callbacks = [] }) => ({
    callbacks: [...callbacks, updateOrCreateMetaDescription]
  }))
);

export const withMetaDescription = compose(
  withMetaData,
);



// WEBPACK FOOTER //
// ./src/Common/Helmet/WithMetaDescription.js